import { Button, Image, UIHeading3, UIText2 } from '@cian/ui-kit';
import React from 'react';

import styles from './styles.css';
import pictureUrl from '../../assets/mortgage-broker.png';

interface IMortgageBrokerSidebarBannerProps {
  linkUrl: string;
  onLinkClick: () => void;
}

export const MortgageBrokerSidebarBanner: React.FC<IMortgageBrokerSidebarBannerProps> = ({ linkUrl, onLinkClick }) => {
  return (
    <aside className={styles['container']}>
      <a
        href={linkUrl}
        className={styles['link-container']}
        target="_black"
        rel="noopener noreferrer"
        onClick={onLinkClick}
        data-testid="mortgage-broker-sidebar-banner"
      >
        <div className={styles['left-side']}>
          <UIHeading3 color="white_100">Циан.Ипотека для профи</UIHeading3>
          <UIText2 color="white_100">Клиенту — новый дом, вам — деньги на счёт</UIText2>
          <div className={styles['button']}>
            <Button theme="fill_white_primary" size="XS">
              Перейти в сервис
            </Button>
          </div>
        </div>
        <div className={styles['image']}>
          <Image src={pictureUrl} loading="lazy" objectFit="contain" width={100} height={100} />
        </div>
      </a>
    </aside>
  );
};
